import ErrorType1 from '@/error/ErrorType1';
import ErrorType2 from '@/error/ErrorType2';
import ErrorType3 from '@/error/ErrorType3';
import ErrorType4 from '@/error/ErrorType4';
import ErrorTypeAuthServer from '@/error/ErrorTypeAuthServer';
import ErrorTypeAuthServer2 from '@/error/ErrorTypeAuthServer2';
import ErrorTypeRaw from '@/error/ErrorTypeRaw';
/**
 * Simple object check.
 * @param item
 * @returns {boolean}
 */
export const isObject = (item) => (item && typeof item === 'object' && !Array.isArray(item));
/**
 * Deep merge two objects.
 * @param target
 * @param ...sources
 */
export const mergeDeep = (target, ...sources) => {
    if (!sources.length) {
        return target;
    }
    const source = sources.shift();
    if (isObject(target) && isObject(source)) {
        // eslint-disable-next-line no-restricted-syntax
        for (const key in source) {
            if (isObject(source[key])) {
                if (!target[key]) {
                    Object.assign(target, {
                        [key]: {},
                    });
                }
                mergeDeep(target[key], source[key]);
            }
            else {
                Object.assign(target, {
                    [key]: source[key],
                });
            }
        }
    }
    mergeDeep(target, ...sources);
    return target;
};
// 객체 깊은 복사
// eslint-disable-next-line consistent-return
export const objDeepCopy = (obj) => {
    if (typeof obj !== 'object' || obj === null) {
        return obj;
    }
    if (obj instanceof Date) {
        return new Date(obj.getTime());
    }
    if (obj instanceof Array) {
        return obj.reduce((arr, item, i) => {
            // eslint-disable-next-line no-param-reassign
            arr[i] = objDeepCopy(item);
            return arr;
        }, []);
    }
    if (obj instanceof Object) {
        return Object.keys(obj).reduce((newObj, key) => {
            // eslint-disable-next-line no-param-reassign
            newObj[key] = objDeepCopy(obj[key]);
            return newObj;
        }, {});
    }
};
/**
 * 두 객체 비교하여 변경사항 여부
 * @param 비교 객체 A
 * @param 비교 객체 B
 * @param ignoreKeyList 무시할 키. undefined로 두어 통일 시킨다.
 * @returns 같으면 true, 다르면 false
 */
export const objDeepCompare = (origin, current, ignoreKeyList = []) => {
    ignoreKeyList.forEach((k) => {
        // eslint-disable-next-line no-param-reassign
        origin[k] = undefined;
        // eslint-disable-next-line no-param-reassign
        current[k] = undefined;
    });
    const A = JSON.stringify(origin);
    const B = JSON.stringify(current);
    return A === B;
};
const getObjectKeys = (obj, depth = 0) => {
    // 2 댑스까지만 탐색
    if (depth > 1) {
        return [];
    }
    const keys = Object.keys(obj).flatMap((key) => {
        const value = obj[key];
        if (typeof value === 'object' && value !== null && depth < 1) {
            return [
                key,
                ...getObjectKeys(value, depth + 1).map((subKey) => `${key}.${subKey}`),
            ];
        }
        return key;
    });
    return keys.sort();
};
/**
 * 오브젝트 구조를 기준으로 비교한다.
 * 값은 확인하지 않고 키만 확인한다
 */
export const compareObjectStructure = (a, b) => {
    const keysA = getObjectKeys(a);
    const keysB = getObjectKeys(b);
    return keysA.toString() === keysB.toString();
};
const errorTypeMap = {
    ErrorType1,
    ErrorType2,
    ErrorType3,
    ErrorType4,
    ErrorTypeAuthServer,
    ErrorTypeAuthServer2,
    ErrorTypeRaw,
};
/**
 * 백엔드에서 주는 에러를 프론트에서 핸들링할 수 있도록 특정 인스턴스로 치환한다.
 */
export const checkErrorObjectType = (responseData) => {
    // pure object
    if (!responseData) {
        return responseData;
    }
    const errorType = Object.keys(errorTypeMap)
        .find((key) => compareObjectStructure(responseData, new errorTypeMap[key]()));
    if (errorType) {
        return new errorTypeMap[errorType](responseData);
    }
    return responseData;
};
